export default function (formName: string, formId: string) {
  if (window._paq && process.client) {
    window._paq.push(['FormAnalytics::trackFormConversion', formName, formId])
  }
}
